import { render, staticRenderFns } from "./NotPurchasedView.vue?vue&type=template&id=611b87f5"
import script from "./NotPurchasedView.vue?vue&type=script&lang=js"
export * from "./NotPurchasedView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports